<template>
  <div>
    <div class="row">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/sites' }">sites</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center">
        <div class="card-transparent">
          <h3 class="card-title text-center">{{ siteName }}</h3>
          <h5 class="description">
            <i class="fa fa-map-marker" aria-hidden="true"></i>
            {{ siteAddress }}
          </h5>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="stationCount.type"
          :icon="stationCount.icon"
          :small-title="stationCount.title"
          :title="stationCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="stationCount.footerIcon"></i>
            {{ stationCount.footerText }}
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="connectionCount.type"
          :icon="connectionCount.icon"
          :small-title="connectionCount.title"
          :title="connectionCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="connectionCount.footerIcon"></i>
            {{ connectionCount.footerText }}
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="bookingCount.type"
          :icon="bookingCount.icon"
          :small-title="bookingCount.title"
          :title="bookingCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="bookingCount.footerIcon"></i>
            {{ bookingCount.footerText }}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h3>Stations</h3>
      </div>
      <div class="col-md-4 offset-md-4">
        <p-button
          class="btn btn-success pull-right"
          @click="handleAddStationButton"
          v-if="hasStationAddPermission"
          >Add Stations</p-button
        >
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-12 card">
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table
              class="table-striped"
              :data="tableData"
              border
              empty-text="This site has no Stations. Click Add Station button to add Stations"
              size="medium"
              style="width: 100%"
              highlight-current-row
            >
              <el-table-column
                v-for="column in stationTableColumns"
                :key="column.label"
                align="center"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
                <template slot-scope="scope">
                  {{ scope.row[column.prop] || "-" }}
                </template></el-table-column
              >
              <el-table-column
                :min-width="120"
                fixed="right"
                class-name="td-actions"
                label="Actions"
              >
                <template slot-scope="props">
                  <p-button
                    type="info"
                    size="sm"
                    icon
                    @click="handleLink(props.$index, props.row)"
                  >
                    <i class="fas fa-link"></i>
                  </p-button>
                  <p-button
                    type="warning"
                    size="sm"
                    icon
                    @click="handleEdit(props.$index, props.row)"
                    v-if="hasStationEditPermission(props.row)"
                  >
                    <i class="fas fa-edit"></i>
                  </p-button>
                  <p-button
                    type="danger"
                    size="sm"
                    icon
                    v-if="hasStationDeletePermission(props.row)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              @input="inputChanged($event)"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- add stations modal -->
    <modal
      :show.sync="addStationsModal"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="text-primary modal-title text-center">
        Add Stations for Site
        <span class="span-site-name">{{ siteName }}</span>
      </h5>

      <template>
        <form>
          <div class="form-group">
            <fg-input
              label="Number of Stations"
              type="number"
              name="numberOfStationsToAdd"
              v-model="numberOfStationsToAdd"
              :error="getError('numberOfStationsToAdd')"
              v-validate="'required|min_value:1'"
            ></fg-input>
          </div>
        </form>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="addStationsModal = false"
          >Close</p-button
        >
        <p-button type="success" @click.native="addStationValidation"
          >Add Stations</p-button
        >
      </template>
    </modal>
    <!-- edit station modal -->
    <modal
      :show.sync="editStationModal"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="text-primary modal-title">
        Edit Station
        <span class="span-site-name"
          >#{{ editStationModel.station_number }}</span
        >
        of Site
        <span class="span-site-name">{{ siteName }}</span>
      </h5>
      <template>
        <form>
          <div class="form-group">
            <fg-input :error="getError('status')">
              <label for="inputType">Status</label>
              <select
                id="inputType"
                name="status"
                class="form-control"
                v-model="editStationModel.status_id"
                v-validate="'required'"
              >
                <option :value="null" disabled>Select Status</option>
                <option
                  v-for="(value, name) in stationStatus"
                  :value="value"
                  v-bind:key="value"
                >
                  {{ name }}
                </option>
              </select>
            </fg-input>
          </div>
        </form>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="editStationModal = false"
          >Close</p-button
        >
        <p-button type="success" @click.native="editStationValidation"
          >Edit Station</p-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import HTTP from "src/util/http-common.js";
import StatsCard from "src/components/UIComponents/Cards/StatsCard";
import { Tooltip } from "element-ui";
import Modal from "src/components/UIComponents/Modal.vue";
import swal from "sweetalert2";
import Vue from "vue";

import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    StatsCard,
    [Tooltip.name]: Tooltip,
    Modal,
  },
  props: ["siteId"],
  data() {
    return {
      stats: [],
      siteName: "",
      siteAddress: "",
      stationCount: {
        type: "warning",
        icon: "fas fa-charging-station",
        title: "Stations",
        value: "",
        footerText: "Updated now",
        footerIcon: "nc-icon nc-refresh-69",
      },
      connectionCount: {
        type: "warning",
        icon: "fas fa-plug",
        title: "Connections",
        value: "",
        footerText: "Updated now",
        footerIcon: "nc-icon nc-refresh-69",
      },
      bookingCount: {
        type: "warning",
        icon: "fas fa-file-invoice",
        title: "Bookings",
        value: "",
        footerText: "Updated now",
        footerIcon: "nc-icon nc-refresh-69",
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0,
      },
      connectionPagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0,
      },
      stationTableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "site_id",
          label: "Site Id",
          minWidth: 150,
        },
        {
          prop: "station_number",
          label: "Station Number",
          minWidth: 125,
        },
        {
          prop: "number_of_connections",
          label: "# of Connections",
          minWidth: 135,
        },
        {
          prop: "created_at",
          label: "Created At",
          minWidth: 200,
        },
        {
          prop: "status_description",
          label: "Status",
          minWidth: 120,
        },
      ],
      tableData: [],
      selectedStationId: null,
      addStationsModal: false,
      numberOfStationsToAdd: 1,
      station_id: null,
      editStationModal: false,
      editStationModel: {},
      stationStatus: {},
      sitePermissions: this.$store.getters["auth/sitePermissions"],
      user_permissions: null,
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    hasStationAddPermission() {
      if (this.user_permissions.includes("site.station.post")) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "pagination.perPage": function (newVal, oldVal) {
      this.pagination.currentPage = 1;
      // this.setBookings();
      this.setStations();
    },
  },
  created() {
    HTTP.get(`api/v1/site/`, {
      params: {
        site_id: this.siteId,
      },
    })
      .then((response) => {
        var data = response.data;
        this.siteName = data.name;
        this.siteAddress = data.address;
      })
      .catch((err) => {
        if (err.response) {
          // Request made and server responded
          const error = err.response.data.error;
          const status_code = err.response.status;
          if ("errors" in err.response.data) {
            swal({
              title: "Bad Request",
              text: err.response.data.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
            return;
          }
          if (status_code == 500) {
            swal({
              title: "Server Error",
              text: "Internal Server Error. Please try again later..",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          } else if (err.response.status === 403) {
            this.$router.push({ name: "forbidden" });
          } else if (err.response.status === 404) {
            this.$router.push({ name: "not-found" });
          } else {
            swal({
              title: "Bad Request",
              text: error,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          }
        } else if (err.request) {
          // The request was made but no response was received
          swal({
            title: "Server Error",
            text: err.request,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-danger btn-fill",
            type: "error",
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          swal({
            title: "Error",
            text: err.message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-danger btn-fill",
            type: "error",
          });
        }
      });
    this.getStationCount();
    this.getConnectionCount();
    this.getBookingCount();
    this.setStations();
    this.user_permissions = localStorage.getItem("permissions");
  },
  methods: {
    inputChanged() {
      this.tableData = [];
      // this.setBookings();
      this.setStations();
    },
    async fetchStationList() {
      const response = await HTTP.get("api/v1/site/station/list", {
        params: {
          site_id: this.siteId,
          page: this.pagination.currentPage,
          page_size: this.pagination.perPage,
        },
      });
      const data = await response.data;
      return data;
    },
    setStations() {
      this.tableData = [];
      let loader = this.$loading.show();
      this.fetchStationList()
        .then((data) => {
          const results = data.results;
          for (var i = 0; i < results.length; i++) {
            results[i]["station_number"] = String(results[i]["station_number"])
            results[i]["number_of_connections"] = results[i].connections.length;
            results[i]["created_at"] = this.$moment
              .unix(results[i].created_at)
              .format("MMMM Do YYYY, h:mm:ss a");
            this.tableData.push(results[i]);
          }
          this.pagination.total = data.total;
          loader.hide();
        })
        .catch((err) => {
          console.log(err);
          loader.hide();
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              this.$notify({
                group: "general",
                title: "Bad Request",
                text: err.response.data.message,
                type: "error",
              });
              return;
            }
            if (status_code == 500) {
              this.$notify({
                group: "general",
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                type: "error",
              });
            } else if (err.response.status === 403) {
              this.$router.push({ name: "forbidden" });
            } else if (err.response.status === 404) {
              this.$router.push({ name: "not-found" });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            this.$notify({
              group: "general",
              title: "Server Error",
              text: err.request,
              type: "error",
            });
          } else {
            this.$notify({
              group: "general",
              title: "Error",
              text: err.message,
              type: "error",
            });
            // Something happened in setting up the request that triggered an Error
          }
        });
    },
    handleLink(index, row) {
      this.$router.push({
        path: `/sites/${this.siteId}/stations/${row.id}`,
      });
      // alert(`Your want to like ${row.id}`)
    },
    handleEdit(index, row) {
      this.editStationModel = Vue.util.extend({}, row);
      this.originalEditConnectionModel = Vue.util.extend({}, row);
      this.editStationModal = true;
      this.setStatus();
      // this.setConnectionTypes();
      // this.setConnectionStatus();
    },
    getStationCount() {
      HTTP.get("api/v1/dashboard/data", {
        params: {
          stat: "station",
          site_id: this.siteId,
        },
      })
        .then((response) => {
          this.stationCount.value = response.data.toString();
        })
        .catch((err) => {
          if (err.response.status == 403) {
            this.$notify({
              group: "general",
              title: "Error getting station stat",
              text: err.response.data.message,
              type: "error",
            });
          }
        });
    },
    getConnectionCount() {
      HTTP.get("api/v1/dashboard/data", {
        params: {
          stat: "connection",
          site_id: this.siteId,
        },
      })
        .then((response) => {
          this.connectionCount.value = response.data.toString();
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "general",
            title: "Error getting connection stat",
            text: err.response.data.message,
            type: "error",
          });
        });
    },
    getBookingCount() {
      HTTP.get("api/v1/dashboard/data", {
        params: {
          stat: "booking",
          site_id: this.siteId,
        },
      })
        .then((response) => {
          this.bookingCount.value = response.data.toString();
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "general",
            title: "Error getting booking stat",
            text: err.response.data.message,
            type: "error",
          });
        });
    },
    handleAddStationButton() {
      this.addStationsModal = true;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async addStationValidation() {
      const isValid = await this.$validator.validate("numberOfStationsToAdd");
      if (isValid) {
        this.addStationAPI();
      }
    },
    addStationAPI() {
      var params = {
        site_id: parseInt(this.siteId),
        number_of_stations: parseInt(this.numberOfStationsToAdd),
      };
      HTTP.post("api/v1/site/station/list", params)
        .then((response) => {
          this.addStationsModal = false;
          swal({
            title: "Successfully Added new Stations",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success",
          });
          this.setStations();
        })
        .catch((err) => {
          this.addStationsModal = false;
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              swal({
                title: "Bad Request",
                text: err.response.data.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
              return;
            }
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            } else if (status_code == 403) {
              this.$notify({
                group: "general",
                title: "Forbidden",
                text: err.response.data.message,
                type: "error",
              });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          }
        });
    },
    async fetchStationStatus() {
      const response = await HTTP.get("api/v1/utils/station/status", {});
      const data = await response.data;
      return data;
    },
    setStatus() {
      this.fetchStationStatus().then((data) => {
        this.stationStatus = data;
      });
    },
    async editStationValidation() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.editStationAPI();
      }
    },
    editStationAPI() {
      var params = {
        //site_id: this.siteId,
        station_id: this.editStationModel.id,
        status_id: this.editStationModel.status_id,
        site_id: this.editStationModel.site_id,
      };
      console.log(params);
      HTTP.put("api/v1/site/station/status", params)
        .then((response) => {
          this.editStationModal = false;
          swal({
            title: "Successfully Updated Station",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success",
          });
          this.setStations();
        })
        .catch((err) => {
          this.editStationModal = false;
          const error = err.response.data.error;
          const reason = err.response.data.message;
          const status_code = err.response.status;
          if (status_code == 500) {
            swal({
              title: "Server Error",
              text: "Internal Server Error. Please try again later..",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          } else {
            swal({
              title: error,
              text: reason,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          }
        });
    },
    hasStationEditPermission(row) {
      var strId = row.site_id.toString();
      if (this.user_permissions.includes("site.station.put")) {
        return true;
      } else {
        return false;
      }
    },
    hasStationDeletePermission(row) {
      var strId = row.site_id.toString();
      if (this.user_permissions.includes("site.station.delete")) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeDestroy() {
    this.connectionTableData = [];
  },
  mounted() {
    var p = localStorage.getItem("permissions");
    var pr = JSON.parse(p);
    var permissions = pr.permissions;

    var canShowsites = permissions.includes("site.get");

    if (canShowsites === false) {
      this.$router.push({ path: "/" });
    }
  },
};
</script>

<style scoped>
.span-site-name {
  text-transform: uppercase;
  color: #848484;
  white-space: nowrap;
}
</style>
